import { z } from 'zod';

const FEATURE_NAMES = [
  'ROI_CALCULATOR',
  'REPORTS',
  'ANALYTICS',
  'GIFT_CARDS',
  'PROGRAMS',
  'PARTNER_FILTER',
  'BRAND_FILTER',
  'KITS_ORDERING',
  'KNOWLEDGE_BASE',
  'CLEAN_OUT',
  'CASH_OUT',
  'BULK_CONSIGNMENT_REPORTS',
  'CASHOUT_TILE',
  'BRAND_PERFORMANCE_THREDUP',
  'DROPSHIPPING',
  'PROGRAMS_ROADMAP_V3'
] as const;

export type FeatureKey = (typeof FEATURE_NAMES)[number];

export const FeatureSchema = z.object({
  key: z.enum(FEATURE_NAMES),
  enabled: z.boolean(),
  details: z.record(z.string(), z.unknown())
});

export type Feature = z.infer<typeof FeatureSchema>;
